export default __webpack_public_path__ + "37beff1c56d119080a25a6958f4ed16d.jpg";